import { render, staticRenderFns } from "./DocsCircularProgressBar.vue?vue&type=template&id=460fd751&scoped=true"
import script from "./DocsCircularProgressBar.vue?vue&type=script&lang=js"
export * from "./DocsCircularProgressBar.vue?vue&type=script&lang=js"
import style0 from "./DocsCircularProgressBar.vue?vue&type=style&index=0&id=460fd751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460fd751",
  null
  
)

export default component.exports